import { Component, EventEmitter, input, Input, InputSignal, OnInit, Output } from '@angular/core';
import { Platform } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';
import { FullscreenBreadcrumb, FullscreenButton } from 'src/app/_interfaces/fullscreen';
import { BreadcumbService } from 'src/app/_provider/breadcumb.service';
import { DarkmodeService } from 'src/app/_provider/darkmode.service';
import { FullscreenService } from 'src/app/_provider/fullscreen.service';
import { MenuService } from 'src/app/_provider/menu.service';
import { ResizeManagerService } from 'src/app/_provider/resize-manager.service';

export interface BreadcrumbCustomOptions{
  breadcrumbs?: FullscreenBreadcrumb[],
  onBack: () => void,
  buttons?: FullscreenButton[]
}

@Component({
    selector: 'app-breadcrump-header',
    templateUrl: './breadcrump-header.component.html',
    styleUrls: ['./breadcrump-header.component.scss'],
    standalone: false
})
export class BreadcrumpHeaderComponent{

  public customOptions: InputSignal<BreadcrumbCustomOptions> = input()

  @Output() backClicked: EventEmitter<boolean> = new EventEmitter<boolean>(null)
  @Input() buttons: FullscreenButton[] = []


  public get breadCrumbs(): FullscreenBreadcrumb[]{
    if(this.customOptions()) return this.customOptions()?.breadcrumbs || []
    return this.breadcrumbSrv.breadcrumbs
  }

  public get fullscreenButtons(): FullscreenButton[]{
    if(this.customOptions()) return this.customOptions()?.buttons || []
    return this.buttons
  }


  constructor(
    public darkmode: DarkmodeService,
    private fullscreenSrv: FullscreenService,
    public breadcrumbSrv: BreadcumbService,
    public platform: Platform,
    public menuSrv: MenuService,
    public resizeManager: ResizeManagerService
  ) { }

  public back(){
    if(this.customOptions()) this.customOptions().onBack()
    else this.breadcrumbSrv.goBack()
  }

}
